import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-dropdown',
    templateUrl: './wdx-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxDropdownComponent {}
